import { css } from '@/styled-system/css';

export const formContainer = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'loose',
});

export const formError = css({
  fontSize: 'body-sm',
  color: 'error',
  padding: 'default',
  background: 'errorBg',
  borderRadius: 'sm',
});

export const privateRelayNote = css({
  display: 'block',
  fontSize: 'body-sm',
  lineHeight: 'body-sm',
  color: 'text.neutral',
  padding: 'tighter',
  background: 'warningBg',
  borderRadius: 'sm',
  marginTop: 'tighter',
});

export const privateRelayNoteLink = css({
  color: 'text.neutral',
  fontWeight: 'semibold',
  textDecoration: 'underline',
});

export const emailPhoneRow = css({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: 'default',
  md: {
    gridTemplateColumns: '1fr 1fr',
  },
});

export const submitRow = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'default',
});

export const legalFootnote = css({
  fontSize: 'body-sm',
  color: 'text.subtle',
  lineHeight: 'body-sm',

  margin: 0,
});
